import { DeleteAccount } from "./DeleteAccount";

export const AccountDangerZone = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span className="text-sm font-bold text-red-100">Delete Account</span>
          <DeleteAccount />
        </div>
        <p className="text-sm text-muted-foreground">
          This action is irreversible and will delete your account and all
          associated data. This action cannot be undone.
        </p>
      </div>
    </div>
  );
};
